<template>
  <div class="recommend">
    <exam :mainConfig="mainConfig" :unionBkzn="unionBkzn" :countDown="countDown" />
    <teacher :teacherList="teacherList" v-if="teacherList.length > 0" />
    <div class="not-teacher" v-else>
      <img src="https://img2.233.com/wx/union/pure/pc/default_no.png" alt="">
      <p>暂无数据</p>
    </div>
    <topic :mainConfig="mainConfig" @openLink="item => $emit('openLink', item)" :skinColor="skinColor" />
  </div>
</template>

<script>
import exam from "./cell/exam"
import teacher from "./cell/teacher"
import topic from "./cell/topic"
export default {
  name: "Recommend",
  components: {
    exam,
    teacher,
    topic
  },
  props: {
    teacherList: {
      type: Array,
      default: () => []
    },
    countDown: {
      type: Object,
      default: () => {}
    },
    mainConfig: {
      type: Object,
      default: () => {}
    },
    unionBkzn: {
      type: Object,
      default: () => {}
    },
    skinColor: {
      type: String,
      default: ""
    }
  }
}
</script>

<style lang="scss" scoped>
.recommend{
  width: 1200px;
  margin: 69px auto 20px;
  height: 404px;
  display: flex;
  justify-content: space-between;
  .not-teacher{
    width: 611px;
    height: 100%;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    p{
      font-size: 15px;
      font-weight: 400;
      color: #878787;
      line-height: 30px;
      margin-top: 12px;
    }
  }
}
</style>